import React from 'react';
import {sortInputFirst} from './utils';
import {components} from 'react-select';

function MenuListSimple(props) {
   if (props.isLoading) {
      return <components.MenuList {...props} />;
   }
   let childrenToRender = props.children;
   if (props && props.selectProps && Boolean(props.selectProps.inputValue)) {
      childrenToRender = sortInputFirst(props.selectProps.inputValue, childrenToRender);
   }
   return <components.MenuList {...props}>{childrenToRender}</components.MenuList>;
}

export default MenuListSimple;
